import { Divider, Modal, Select, message } from "antd";
import React, { useEffect, useState } from "react";
import { CloseOutlined } from "@ant-design/icons";
import useAxios from "../../../hooks/useAxios";
import { ReactLoading } from "../../Dashboard/TinManagement/import";
import LoadingArea from "../../../components/LoadingArea";

const { Option } = Select;

const NotFitCandidate = ({
  setNotFitPopup,
  notFitPopup,
  candidate,
  setIsModalOpen,
  loadCandidates,
  accepted,
  tab,
}) => {
  const [department, setDepartment] = useState(null);
  const [title, setTitle] = useState(null);
  const [notFirLoading, setNotFirLoading] = useState(false);
  const [designations, setDesignations] = useState([]);
  const [departments, setDepartments] = useState([]);
  const api = useAxios();
  const proceed_with_updated_role_disable = !department || !title;
  const move_to_talent_pool_disable = department
    ? !department || !title
    : title
    ? !department
    : false;

  const getDepartments = async () => {
    try {
      const { data } = await api.get(`/trfdepartment`, {
        tokenType: "user",
      });

      const { trfDepartment } = data;
      setDepartments(trfDepartment.filter((e) => e.status));
    } catch (err) {
      console.error(err);
    }
  };

  const getDesignations = async (departmentId) => {
    try {
      const { data } = await api.get(
        `/departmentBasedDesignation/departmentId/${departmentId}`,
        {
          tokenType: "user",
        }
      );

      const { data: allDepartments } = data || {};
      const raw = allDepartments?.filter((e) => e.status);
      setDesignations(raw);
      if (raw.length === 0) {
        setTitle(null);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (!candidate) return;
    getDepartments();
  }, [candidate]);

  useEffect(() => {
    if (!department) return;

    const init = async () => {
      try {
        setNotFirLoading(true);
        await getDesignations(department);
      } catch (err) {
        console.error(err);
      } finally {
        setNotFirLoading(false);
      }
    };

    init();
  }, [department]);

  const move_to_talent_pool = async (e) => {
    try {
      setNotFirLoading(true);
      await api.post(
        `/fitNotFit`,
        {
          candidateId: candidate?._id,
          departmentId: department,
          designationId: title,
          remarks: "",
          isMoveTalentPool: true,
          status: true,
        },
        {
          tokenType: "user",
        }
      );
      await loadCandidates();
      message.success("Candidate moved to talent pool successfully");
      setNotFitPopup(false);
      setIsModalOpen(false);
    } catch (err) {
      console.error(err);
    } finally {
      setNotFirLoading(false);
    }
  };

  const proceed_with_updated_role = async (e) => {
    if (!candidate?.isNonAgent) {
      return message.error(
        "Department and Designation cannot be changed for Agents."
      );
    }

    try {
      setNotFirLoading(true);
      await api.post(
        `/fitNotFit`,
        {
          candidateId: candidate?._id,
          departmentId: department,
          designationId: title,
          remarks: "",
          isMoveTalentPool: false,
          status: true,
        },
        {
          tokenType: "user",
        }
      );
      setIsModalOpen(false);
      setIsModalOpen(false);
      message.success(
        "Candidate department and designation updated successfully"
      );
      accepted(candidate?._id);
    } catch (err) {
      console.error(err);
    } finally {
      setNotFirLoading(false);
    }
  };

  return (
    <>
      <Modal
        title=""
        className="p-0 custom_modal__"
        centered
        closable={null}
        open={notFitPopup}
        width={600}
        closeIcon={null}
        footer={null}
        onCancel={(e) => setNotFitPopup(false)}
      >
        <LoadingArea isLoading={notFirLoading}>
          <div>
            <div className="modal-header d-flex justify-content-between align-items-center active-color-modal text-white w-100">
              <h5
                className="modal-title text-white text-capitalize font-weight-bold"
                style={{ fontSize: "18px", fontWeight: 400 }}
              >
                Mark as Not - Fit - {candidate?.name || ""}
              </h5>
              <button onClick={(e) => setNotFitPopup(false)}>
                <CloseOutlined />
              </button>
            </div>
            <div className="row py-3 px-4 ">
              <div className="w-100">
                <div className="col-12 p-3">
                  <div className="d-flex __custom_row">
                    <div style={{ flex: "1 1", width: "100%" }}>
                      {/* <div className="row">
                      <div className="col-md-12 mb-2">
                        <label>
                          Reason <span style={{ color: "red" }}>*</span>
                        </label>
                        <div>
                          <Select
                            showSearch
                            value={reason}
                            className="w-100 p-0 outline-none bg-white increase_drop"
                            placeholder="Select Reason"
                            optionFilterProp="children"
                            filterOption={(input, option) => {
                              return (
                                option?.children
                                  ?.toLowerCase()
                                  ?.indexOf(input.toLowerCase()) >= 0 ||
                                option.value
                                  ?.toLowerCase()
                                  ?.indexOf(input.toLowerCase()) >= 0
                              );
                            }}
                            onChange={(value) => {
                              setReason(value);
                            }}
                          >
                            <Option value={null}>Select Reason</Option>
                            <Option value={"Notice Period"}>Notice Period</Option>
                          </Select>
                        </div>
                      </div>
                    </div>
                    <Divider style={{ margin: "20px 0" }} /> */}
                      <div className="row">
                        <div className="col-md-12 mb-2">
                          <h1 className="h5">
                            Suggest Alternative Position (Optional)
                          </h1>
                        </div>
                        <div className="col-md-12 mb-2">
                          <label>Relevant Department</label>
                          <div>
                            <Select
                              showSearch
                              value={department}
                              className="w-100 p-0 outline-none bg-white increase_drop"
                              placeholder="Select Department"
                              optionFilterProp="children"
                              filterOption={(input, option) => {
                                return (
                                  option?.children
                                    ?.toLowerCase()
                                    ?.indexOf(input.toLowerCase()) >= 0 ||
                                  option.value
                                    ?.toLowerCase()
                                    ?.indexOf(input.toLowerCase()) >= 0
                                );
                              }}
                              onChange={(value) => {
                                if (!value) {
                                  setDesignations([]);
                                }
                                setTitle(null);
                                setDepartment(value);
                              }}
                            >
                              <Option value={null}>Select Department</Option>
                              {departments?.map((dept) => {
                                return (
                                  <Option key={dept?._id} value={dept?._id}>
                                    {dept?.department || ""}
                                  </Option>
                                );
                              })}
                            </Select>
                          </div>
                        </div>
                        <div className="col-md-12 mb-2">
                          <label>Relevant Job Title</label>
                          <div>
                            <Select
                              showSearch
                              value={title}
                              className="w-100 p-0 outline-none bg-white increase_drop"
                              placeholder="Select Job Title"
                              optionFilterProp="children"
                              filterOption={(input, option) => {
                                return (
                                  option?.children
                                    ?.toLowerCase()
                                    ?.indexOf(input.toLowerCase()) >= 0 ||
                                  option.value
                                    ?.toLowerCase()
                                    ?.indexOf(input.toLowerCase()) >= 0
                                );
                              }}
                              onChange={(value) => {
                                setTitle(value);
                              }}
                            >
                              <Option value={null}>Select Job Title</Option>
                              {designations?.map((deg) => {
                                return (
                                  <Option key={deg?._id} value={deg?._id}>
                                    {deg?.designation}
                                  </Option>
                                );
                              })}
                            </Select>
                          </div>
                        </div>
                      </div>
                      <Divider style={{ margin: "20px 0" }} />
                      <div className="row">
                        <div className="col-12">
                          <button
                            onClick={proceed_with_updated_role}
                            disabled={proceed_with_updated_role_disable}
                            className={`${
                              proceed_with_updated_role_disable
                                ? "bg-[#d7d7d7]"
                                : "bg-blue-600"
                            } w-100 font-weight-bold text-white border-0 rounded px-4 py-2`}
                          >
                            Proceed with Updated Role
                          </button>
                        </div>
                        {tab !== "TalentPool" && (
                          <div className="col-12 mt-2">
                            <button
                              disabled={move_to_talent_pool_disable}
                              onClick={move_to_talent_pool}
                              className={`${
                                move_to_talent_pool_disable
                                  ? "bg-[#d7d7d7]"
                                  : "add-new-btn"
                              } w-100 font-weight-bold text-white border-0 rounded px-4 py-2`}
                            >
                              Move to Talent Pool
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </LoadingArea>
      </Modal>
    </>
  );
};

export default NotFitCandidate;
